
<template>
<v-card flat color="#f5f5f5">
    <v-container fluid :class="{ 'px-0': $vuetify.breakpoint.smAndDown, 'pt-3': true}">
        <!-- start meta components-->
        <v-row no-gutters>
            <v-col cols="6" md="4" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Languages</div>
                    <im-place-meta>
                        <v-autocomplete slot="main-content" class="im-select pa-0 ma-0" flat solo clearable hide-details multiple v-model="item.meta.languages" :items="config.languages" item-value="code" item-text="name" placeholder="Languages"
                            :menu-props="{ transition:'scale-transition', 'offset-y': ''}">
                        </v-autocomplete>
                    </im-place-meta>
                </v-card>
            </v-col>
            <v-col cols="6" md="4" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold">Currency</div>
                    <v-autocomplete class="im-select pa-0 ma-0" flat solo clearable hide-details v-model="item.meta.currency" :items="config.currencies" item-value="code" item-text="name" placeholder="Currency" :menu-props="{ transition:'scale-transition', 'offset-y': ''}">
                        <template v-slot:selection="data">{{ data.item.name }} ({{ data.item.code }})</template>
                        <template v-slot:item="data">{{ data.item.name }} ({{ data.item.code }})</template>
                    </v-autocomplete>
                </v-card>
            </v-col>
            <v-col cols="6" md="4" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Timezone</div>
                    <v-autocomplete class="im-select pa-0 ma-0" flat solo clearable hide-details v-model="item.meta.timezone" :items="config.timezones" placeholder="Timezone" :menu-props="{ transition:'scale-transition', 'offset-y': ''}" />
                </v-card>
            </v-col>

            <v-col cols="6" md="6" class="pa-2">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold">Visas</div>
                    <im-place-meta v-model="item.meta.visas" />
                </v-card>
            </v-col>

            <v-col cols="6" md="6" class="pa-2">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Money</div>
                    <im-place-meta v-model="item.meta.money" />
                </v-card>
            </v-col>

            <v-col cols="6" md="6" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Mobile Phones</div>
                    <im-place-meta v-model="item.meta.mobile_phones" />
                </v-card>
            </v-col>

            <v-col cols="6" md="6" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Websites</div>
                    <im-place-meta v-model="item.meta.websites" />
                </v-card>
            </v-col>

            <v-col cols="6" md="6" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Important Numbers</div>
                    <im-place-meta v-model="item.meta.important_numbers" />
                </v-card>
            </v-col>

            <v-col cols="6" md="6" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Opening hours</div>
                    <im-place-meta v-model="item.meta.opening_hours" />
                </v-card>
            </v-col>

            <v-col cols="6" md="6" class="px-2 py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Arriving</div>
                    <im-place-meta v-model="item.meta.arriving" />
                </v-card>
            </v-col>

            <v-col cols="6" md="6" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Getting Around</div>
                    <im-place-meta v-model="item.meta.getting_around" />
                </v-card>
            </v-col>

            <v-col cols="6" md="6" :class="[ 'px-2 py-1',(item.type == 'country')?'':'d-none']">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Working Hours</div>
                    <im-meta-working-hours :item="item" />
                </v-card>
            </v-col>

            <v-col cols="6" md="6" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Contact</div>
                    <im-place-meta v-model="item.meta.contact" />
                </v-card>
            </v-col>


            <v-col cols="6" md="6" :class="['',(item.type == 'city')?'px-2 py-1':'d-none']">
                <v-card class="mb-3 elevation-1 pa-2">
                    <v-expansion-panels flat>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="detail font-weight-bold pa-0 ma-0">Weather </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <im-meta-weather class="pr-2" ref="weather" :weather="item.meta.weather"></im-meta-weather>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-card>
            </v-col>

            <v-col cols="6" md="6" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Daily Costs</div>
                    <template v-for="(cost, index) in item.meta.daily_costs">
                        <v-row align="center" no-gutters>
                            <v-col cols="3" class="pa-1">
                                <div class="mb-0 text-xs-center">{{ cost.type }}</div>
                            </v-col>
                            <v-col cols="3" class="pa-1">
                                <v-text-field label="Min" class="ma-0 pa-0" type="number" v-model="cost.min"></v-text-field>
                            </v-col>
                            <v-col cols="3" class="pa-1">
                                <v-text-field label="Max" class="ma-0 pa-0" type="number" v-model="cost.max"></v-text-field>
                            </v-col>
                            <v-col cols="3" class="pa-1">
                                <v-autocomplete :items="config.currencies" label="Currency" class="ma-0 pa-0" v-model="cost.money" item-value="code" item-text="name" clearable />
                            </v-col>
                        </v-row>
                        <im-place-meta v-model="cost.description">
                        </im-place-meta>
                    </template>
                </v-card>
            </v-col>

            <v-col cols="6" md="6" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">When To Go</div>
                    <template v-for="(period, index) in item.meta.when_to_go">
                        <im-place-meta v-model="period.description">
                            <v-row slot="header-content" align="center" no-gutters>
                                <v-col cols="4">
                                    <div class=" pa-1 mb-0 text-xs-center">{{ period.type }}</div>
                                </v-col>
                                <v-col cols="8">
                                    <div class="pa-1 d-flex align-center">
                                        <v-select :items="months" v-model="period.start_date" item-value="value" item-text="text" label="Start period" />
                                        <v-icon small class="mx-1">arrow_forward</v-icon>
                                        <v-select :items="months" v-model="period.end_date" label="End period" />
                                    </div>
                                </v-col>
                            </v-row>
                        </im-place-meta>
                    </template>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    <slot name="actions"></slot>

</v-card>
</template>

<script>
import {
    mapActions
} from "vuex";
import defaults from "../../utils/PropDefaults.js";
import IMPlaceSearch from "../../utils/IMPlaceSearch";
import IMPlaceMeta from "./PlaceMeta";
import IMPlaceMetaWeather from "./MetaWeather";
import IMPlaceMetaWorkingHours from "./MetaWorkingHours";
export default {
    components: {
        "im-place-search": IMPlaceSearch,
        "im-place-meta": IMPlaceMeta,
        "im-meta-weather": IMPlaceMetaWeather,
        "im-meta-working-hours": IMPlaceMetaWorkingHours,
    },
    props: {
        item: {
            type: Object,
            default: function () {
                return this.$clone(defaults.place_item)
            }
        },
        config: {
            type: Object,
            default () {
                return {
                    place_types: [],
                    timezones: [],
                    languages: [],
                    countries: [],
                    currencies: [],
                }
            }
        },
    },

    data() {
        return {
            //validation
            valid: true,
            errors: [],
            months: [
                {
                    text: "January",
                    value: "january"
                }, {
                    text: "February",
                    value: "february"
                }, {
                    text: "March",
                    value: "march"
                }, {
                    text: "April",
                    value: "april"
                }, {
                    text: "May",
                    value: "may"
                }, {
                    text: "June",
                    value: "june"
                }, {
                    text: "July",
                    value: "july"
                }, {
                    text: "August",
                    value: "august"
                }, {
                    text: "September",
                    value: "september"
                }, {
                    text: "October",
                    value: "cctober"
                }, {
                    text: "November",
                    value: "november"
                }, {
                    text: "December",
                    value: "december"
                },
            ]
        };
    },

    methods: {
        ...mapActions("alert", ["success", "error"]),

    }
};
</script>
<style>
.meta-expasion.v-expansion-panel .v-expansion-panel__header {
    padding: 0;
}
</style>
